// Force any user-entered URL to https so it never triggers mixed-content
// warnings on the (HTTPS) site. Protocol-relative URLs become https too.
export function httpsify(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('http://')) return `https://${url.slice(7)}`;
  if (url.startsWith('//')) return `https:${url}`;
  return url;
}
